import { DBLocalMenu, DBLocalMenuIcon } from "@/enumLocal/menu";
import { i18nGlobal } from "@/i18n";
import { routesName } from '@/plugins/router';
import { DBAuthProfile, DBRole } from "@functions/models/DBEnum";

export interface minisidebar {
    icon?: string;
    id?: DBLocalMenu;
    tooltip?: string
    authProfile: DBAuthProfile[]
    role: DBRole[]
    to?: string
}
const MiniSideIcons: minisidebar[] = [
    {
        icon: DBLocalMenuIcon.HOME,
        tooltip: i18nGlobal.t( 'menu.home' ),
        id: DBLocalMenu.HOME,
        authProfile: [ DBAuthProfile.CLIENT, DBAuthProfile.MANAGER, DBAuthProfile.SELLER, ],
        role: [ DBRole.ADMIN, DBRole.USER ],
        to: routesName.home
    },
    {
        icon: DBLocalMenuIcon.QUOTE,
        tooltip: i18nGlobal.t( 'menu.quote.quote' ),
        id: DBLocalMenu.QUOTE,
        role: [ DBRole.ADMIN, DBRole.USER ],
        authProfile: [ DBAuthProfile.CLIENT, DBAuthProfile.MANAGER, DBAuthProfile.SELLER ]
    },
    {
        //  icon: 'notes-line-duotone',
        icon: DBLocalMenuIcon.SETTINGS,
        tooltip: i18nGlobal.t( 'menu.settings.settings' ),
        id: DBLocalMenu.SETTINGS,
        role: [ DBRole.ADMIN, DBRole.USER ],
        authProfile: [ DBAuthProfile.CLIENT, DBAuthProfile.MANAGER, DBAuthProfile.SELLER ]
    },
    {
        icon: DBLocalMenuIcon.MANAGER,
        tooltip: i18nGlobal.t( 'menu.manager.manager' ),
        id: DBLocalMenu.MANAGER,
        role: [ DBRole.ADMIN, DBRole.USER ],
        authProfile: [ DBAuthProfile.MANAGER ]
    },
    {
        icon: DBLocalMenuIcon.SUPERADMIN,
        tooltip: i18nGlobal.t( 'menu.superAdmin.superAdmin' ),
        id: DBLocalMenu.SUPERADMIN,
        role: [ DBRole.ADMIN ],
        authProfile: [ DBAuthProfile.MANAGER ]
    },
    /*
        {
            icon: 'align-vertical-spacing-broken',
            tooltip: 'Tables',
            id: 4,
            authProfile: DBAuthProfile.CLIENT
        },
        {
            icon: 'chart-line-duotone',
            tooltip: 'Charts',
            id: 5,
            authProfile: DBAuthProfile.CLIENT
        },
        {
            icon: 'widget-6-line-duotone',
            tooltip: 'UI Components',
            id: 6,
            authProfile: DBAuthProfile.CLIENT
        },
        {
            icon: 'lock-keyhole-line-duotone',
            tooltip: 'Authentication Pages',
            id: 7,
            authProfile: DBAuthProfile.CLIENT
        },
        {
            icon: 'mirror-left-line-duotone',
            tooltip: 'Others',
            id: 8,
            authProfile: DBAuthProfile.CLIENT
        }*/
]

export default MiniSideIcons;
